import Route from "@ember/routing/route";
import { service } from "@ember/service";

import { runs } from "virtual:result-sets";

import type RouterService from "@ember/routing/router-service";

export default class Index extends Route {
  @service declare router: RouterService;

  beforeModel() {
    this.router.transitionTo("results", {
      queryParams: {
        q: runs[0],
      },
    });
  }
}
